export const CSS = {
	image: 'c-PMZoom__Image',
	container: 'c-PMZoom__Container',
	crosshair: 'c-PMZoom__Crosshair',
	crosshairOuterline: 'c-PMZoom__Outerline',
	crosshairInnerline: 'c-PMZoom__Innerline',
	crosshairCaliper: 'c-PMZoom__Caliper',
};

export const Style = {
	[CSS.container]: {
		position: 'relative',
	},
	[CSS.image]: {
		position: 'absolute',
		'transform-origin': 'top left',
		top: 0,
		left: 0,
	},
	[CSS.crosshair]: {
		position: 'absolute',
	},
};

export const CALIPER_OUTERLINE_STROKE = 'black';
export const CALIPER_OUTERLINE_STROKE_WIDTH = '1.5px';
export const CALIPER_INNERLINE_STROKE = 'white';
export const CALIPER_INNERLINE_STROKE_WIDTH = '1px';

export const OUTERLINE_STROKE = 'black';
export const OUTERLINE_STROKE_WIDTH = '2.5px';
export const INNERLINE_STROKE = 'white';
export const INNERLINE_STROKE_WIDTH = '2px';
